import React, { useEffect } from "react";
import MenuItemLayout from "./MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import { toGetPhotoAlbum } from "../../../apis/actions/photoVideos.actions";
import { AppDispatch, RootState } from "../../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import PreviewMedia from "../../../biblio/PreviewMedia/PreviewMedia";
import Loader from "../../../biblio/Loader/Loader";

const PhotoAlbum = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { photos, loading } = useSelector(
    (state: RootState) => state.photoVideo
  );

  useEffect(() => {
    dispatch(toGetPhotoAlbum());
  }, [dispatch]);

  if (loading) return <Loader />;

  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="المركز الإعلامي"
      subTitle={" الصور"}
      urlImage={banner}
      className="takaful--our-story"
    >
      <PreviewMedia
        mediaItems={photos}
        loading={loading}
        itemPerPage={6}
        isVideo={false}
      />
    </MenuItemLayout>
  );
};

export default PhotoAlbum;
